import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getInvoices = async (selectedCustomerId) => {
  let customerId = localStorage.getItem('customer_id');
  if (selectedCustomerId) {
    customerId = selectedCustomerId;
  }
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${BASE_URL}/api/invoices?customer_id=${customerId}`, settings);
}

export const getInvoiceSpecs = async (invoiceNumber, filterData, csv) => {
  let customerId = localStorage.getItem('customer_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };
  let urlQueries = '';
  if (filterData.selectedTeam !== 'all') {
    urlQueries += '&team_id=' + filterData.selectedTeam;
  }
  if (filterData.selectedType !== 'all') {
    urlQueries += '&item_type=' + filterData.selectedType;
  }
  if (filterData.selectedRegion !== 'all') {
    urlQueries += '&region=' + filterData.selectedRegion;
  }
  if (csv) {
    urlQueries += '&format=csv';
  }

  return axios.get(`${BASE_URL}/api/invoice/lines?customer_id=${customerId}&invoice_number=${invoiceNumber}${urlQueries}`, settings);
}
